import workbench from "./modules/workbench";
import clue from "./modules/clue";
import site from "./modules/site";
import setting from "./modules/setting";
import perm from "./modules/perm";

export default [...workbench, ...clue, ...site, ...setting, ...perm];
